/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1JpmamTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_JPMAM_TASK_STATE_ENTITY_NAME = 'exc.jpmam.v1.JpmamTask';
export const excJpmamV1JpmamTaskStateEntity = new schema.Entity<ExcJpmamV1JpmamTaskState>(EXC_JPMAM_V1_JPMAM_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'jpmamTaskId' });

